// extracted by mini-css-extract-plugin
export default {"contenedor":"contenidoModal_contenedor__nG79c","p":"contenidoModal_p__1NpD8","pie":"contenidoModal_pie__BIsyX"};